export const getChartDisplayConfig = (chart: ChartBlockAttributes) => {
    return {
        label: chart.title,
        abbreviation: chart.display.abbreviation,
        autoAbbreviation: chart.display.autoAbbreviation,
        decimalPlaces: chart.display.decimalPlaces,
    }
}
